import geolib from 'geolib';

const google = typeof window !== 'undefined' ? (window as any).google : undefined;

function getGeoParams(search: string) {
  let waAddress = search;
  if (!search) {
    waAddress = '6000';
  }
  if (!search.endsWith(' WA')) {
    waAddress += ' WA';
  }
  return {
    address: waAddress,
    componentRestrictions: {
      country: 'AU',
    },
  };
}

export async function sortLocations(entries: LocationFragment[], search: string) {
  return new Promise<LocationWithDistance[]>((res) => {
    if (!process.browser || !entries) {
      res([]);
    }

    const locations = entries.map((l) => ({
      latitude: l.address?.lat || 0,
      longitude: l.address?.lng || 0,
    }));
    const sorted: LocationWithDistance[] = [];

    const geocoder = new google.maps.Geocoder();
    geocoder.geocode(getGeoParams(search), (results: any, status: any) => {
      if (status === 'OK') {
        const location = {
          latitude: results[0].geometry.location.lat(),
          longitude: results[0].geometry.location.lng(),
        };
        const pointers = geolib.orderByDistance(location, locations);

        for (let i = 0; i < pointers.length; i++) {
          if (entries && entries?.[parseInt(pointers[i].key)]) {
            sorted.push({ location: entries[parseInt(pointers[i].key)], distance: pointers[i].distance });
          }
        }
        res(sorted);
      }

      res([]);
    });
  });
}
